module.exports = __webpack_public_path__ + "components/flag/static/square/my-48e93203614f1f00a7ea27282a58ebb5.svg";